import isArray from 'lodash/isArray';
import { useToastContext } from 'context/ToastContext';
import { unSubcribeFirebase } from 'utils/FirebaseUtils';
import { getObjectiveLocale } from 'utils/HelperUtils';
const useNetworkError = () => {
    const { addToast } = useToastContext();
    const pushError = (error) => {
        const message = error?.message;
        const title = error?.title;
        if (isArray(message)) {
            message?.map((mes) => {
                mes?.errors?.map((msg) => {
                    addToast({
                        title: getObjectiveLocale(title || 'Failed'),
                        msg: msg,
                        type: 'error',
                        dataCy: 'warning-toast'
                    });
                });
            });
        }
        else {
            addToast({
                title: getObjectiveLocale(title || 'Failed'),
                msg: message,
                type: 'error',
                dataCy: 'warning-toast'
            });
        }
    };
    const showErrorToast = (endpoint, err) => {
        if (!endpoint?.includes('auth') &&
            !endpoint?.includes('password') &&
            !endpoint?.includes('send_activation') &&
            !endpoint?.includes('integrations')) {
            switch (err?.code) {
                case 401:
                    if (!window.Cypress && !localStorage.getItem('tokenInvalid')) {
                        'Notification' in window &&
                            Notification.permission !== 'denied' &&
                            unSubcribeFirebase();
                        localStorage.setItem('tokenInvalid', true.toString());
                        alert(err.message);
                        location.replace('/login/email');
                    }
                    break;
                case 422:
                    err.message =
                        err?.message?.length > 200
                            ? 'Something went wrong on our side! Please try again later'
                            : err?.message;
                    pushError(err);
                    break;
                case 403:
                    pushError({
                        message: err?.message || 'Not Allowed',
                        code: 403
                    });
                    break;
                case 404:
                case 429:
                    pushError(err);
                    break;
                case 500:
                    pushError({
                        message: 'Something went wrong on our side! Please try again later',
                        code: 500
                    });
                    break;
                default:
                    break;
            }
        }
    };
    const globalHandler = (error) => {
        const endpoint = error?.config?.url;
        const err = error?.response?.data?.error
            ? error?.response?.data?.error
            : error?.response?.data?.errors;
        const resultError = {
            ...error,
            showErrorToast: () => showErrorToast(endpoint, err)
        };
        return Promise.reject(resultError);
    };
    return { pushError, globalHandler };
};
export default useNetworkError;
